import options from './alert-box.component';

export default {
    selector: 'dtAlertBox',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/alert-box/index.js